// AuthContext.jsx
import React, { createContext, useContext, useEffect, useState } from 'react';
import {
  onAuthStateChanged,
  signInWithPopup,
  signOut
} from 'firebase/auth';
import alertify from '../lib/alertifySetup';
import { auth, googleProvider, logAnalyticsEvent } from '../firebase';
import { ensureUserProfile, subscribeUserProfile } from '../lib/gameStorage';
import { langFromPath } from '../i18n';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loggingIn, setLoggingIn] = useState(false);

  // Auth Durum Dinleyicisi
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      setUser(firebaseUser);
      if (firebaseUser) {
        try {
          await ensureUserProfile(firebaseUser);
        } catch (e) {
          console.error('Profil hatası:', e);
        }
      } else {
        setProfile(null);
      }
      setLoading(false);
      setLoggingIn(false);
    });
    return unsubscribe;
  }, []);

  // Canlı Profil Dinleyicisi
  useEffect(() => {
    if (!user) return undefined;
    const unsubscribe = subscribeUserProfile(user.uid, setProfile);
    return unsubscribe;
  }, [user]);

  // Mobilde ve Masaüstünde Direkt Popup Girişi
  const login = async () => {
    if (loggingIn) return;
    setLoggingIn(true);

    try {
      // signInWithPopup mobilde çerez engellerine takılmaz ve oturumu doğrudan açar
      await signInWithPopup(auth, googleProvider);
      alertify.success(langFromPath(window.location.pathname) === 'en' ? 'Signed in!' : 'Giriş başarılı!');
      logAnalyticsEvent('login', { method: 'Google' });
    } catch (err) {
      setLoggingIn(false);
      console.error('Giriş hatası:', err);
      if (
        err.code !== 'auth/popup-closed-by-user' &&
        err.code !== 'auth/cancelled-popup-request'
      ) {
        alertify.error(`${langFromPath(window.location.pathname) === 'en' ? 'Sign-in error' : 'Giriş hatası'}: ${err.code || err.message}`);
      }
    }
  };

  const logout = () => {
    // 📊 Analytics: Çıkış yapıldı
    logAnalyticsEvent('logout');
    return signOut(auth);
  };

  return (
    <AuthContext.Provider value={{ user, profile, loading, loggingIn, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}